import React from 'react';

import { AccountForm as AccountFormCinderblocks } from '../AccountFormCinderblocks';
import type { IAccountFormProps } from '../AccountFormCinderblocks/AccountForm';

/**
 * V2 stub. Until the real implementation lands we render the V1 cinderblocks
 * form so that a stray flag flip (misconfigured rollout, accidental targeting,
 * QA flag bleed) does not blank out a consumer's auth surface.
 */
export type AccountFormV2Props = IAccountFormProps;

export const AccountFormV2: React.FC<AccountFormV2Props> = (props) => (
  <AccountFormCinderblocks {...props} />
);
